import React from 'react'

import Box from '@components/kit/box'
import Text from '@components/kit/text'
import Pressable from '@components/kit/pressable'
import { CloseIcon } from '@components/kit/icons'

import { TextFieldFormated } from '@components/formFields'

interface IEditOpportunityProps {
  label: string
}

function FakeButton({ label }: IEditOpportunityProps) {
  return (
    <Box
      backgroundColor={'walrusBlue100'}
      paddingX='08'
      style={{ paddingTop: 6, paddingBottom: 6, borderRadius: 4 }}
    >
      <Text font='text.12.bold' textColor='white'>
        {label}
      </Text>
    </Box>
  )
}

interface IHomepageQuestionCardProps {
  title: string
  description: string
  onChangeTitle: (title: string) => void
  onChangeDescription: (description: string) => void
  onRemove: () => void
  isRemovable: boolean
}

export function HomepageQuestionCard({
  title,
  description,
  onChangeTitle,
  onChangeDescription,
  onRemove,
  isRemovable
}: IHomepageQuestionCardProps) {
  return (
    <Box
      padding='12'
      backgroundColor='walrusNeutralSecondary'
      boxShadow='medium'
      gap='12'
    >
      <Box
        width='100%'
        flexDirection='row'
        justifyContent={isRemovable ? 'space-between' : 'flex-start'}
        alignItems='center'
        marginBottom='12'
      >
        <Text font='text.11.bold' textColor='purple' textTransform='uppercase'>
          Homepage Question Card
        </Text>
        {isRemovable && (
          <Pressable onPress={onRemove}>
            <CloseIcon width={10} height={10} fill='violet' />
          </Pressable>
        )}
      </Box>
      <TextFieldFormated
        name='title'
        value={title}
        label=''
        onChangeText={onChangeTitle}
        valuePlaceholder='Enter the Title of the question'
        backgroundColor='walrusNeutralSecondary'
        borderColor='walrusBlue100'
        labeless
      />
      <TextFieldFormated
        name='description'
        value={description}
        label=''
        onChangeText={onChangeDescription}
        valuePlaceholder='Enter the Description of the question'
        backgroundColor='walrusNeutralSecondary'
        borderColor='walrusBlue100'
        multiline
        maxLength={500}
        numberOfLines={3}
        height='4.5em'
        labeless
      />
      <Box width='100%' flexDirection='row' justifyContent='flex-end' gap='12'>
        <FakeButton label='No' />
        <FakeButton label='Yes' />
      </Box>
    </Box>
  )
}
